import script from "./createSchool.vue?vue&type=script&setup=true&lang=js"
export * from "./createSchool.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__